import React, { Component } from 'react';
import axios from 'axios';
import config from '../../../../../config';
import SaveButton from '../../../../commons/Buttons/SaveButton';

export default class Billing extends Component {
    state = {
        isSaving: false,
        vat: '12',
        senior_citizen: '20'
    };

    handleChange = (e) => {
        let data = {};
        data[e.target.id] = e.target.value;

        this.setState(data);
    };

    handleClick = () => {
        this.setState({
            isSaving: true
        });

        let data = {
            type: 'billing',
            vat: this.state.vat,
            senior_citizen: this.state.senior_citizen
        };

        let url = `${config.apiUrl}settings`;

        axios.post(url, data).then((res) => {
            console.log(res);

            this.setState({
                isSaving: false
            });

            this.props.showNotification('success', 'Settings Updated!');
        }).catch((error) => {
            console.log(error);

            this.setState({
                isSaving: false
            });

            this.props.showNotification('error', 'Failed to update settings');
        });
    };

    mapSettingsParameters = (settings) => {
        for (let setting of settings) {
            if (setting.type !== 'billing') {
                continue;
            }

            let data = {};
            data[setting.param] = setting.value;

            this.setState(data);
        }
    };

    componentDidMount() {
        this.mapSettingsParameters(this.props.settings);
    }

    componentWillReceiveProps(nextProps) {
        this.mapSettingsParameters(nextProps.settings);
    }

    render() {
        return (
            <div id="general_settings_container" ref="container">
                <div className="row">
                    <form action="">
                        <div className="form-group form-md-line-input col-md-12 col-lg-12 col-sm-12">
                            <label className="col-md-2 control-label" htmlFor="vat">
                                VAT
                                <br/>
                                <small>VAT Percentage of your services</small>
                            </label>
                            <div className="col-md-10">
                                <input type="number" className="form-control"
                                        value={this.state.vat}
                                        onChange={this.handleChange}
                                        id="vat" />
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <div className="form-group form-md-line-input col-md-12 col-lg-12 col-sm-12">
                            <label className="col-md-2 control-label" htmlFor="senior_citizen">
                                Senior Citizen Discount
                                <br/>
                                <small>Senior Citizen Discount</small>
                            </label>
                            <div className="col-md-10">
                                <input type="number" className="form-control"
                                        value={this.state.senior_citizen}
                                        onChange={this.handleChange}
                                        id="senior_citizen" />
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <hr/>

                        <div className="form-actions col-md-12 col-lg-12 col-sm-12"
                             style={{ borderTop: '1px #eef1f5 solid', paddingTop: '20px' }}>
                            <div className="btn-set pull-right" style={{ width: '150px' }}>
                                <SaveButton name="Save" loadingName="Saving"
                                            onClickEvent={this.handleClick}
                                            isLoading={this.state.isSaving}
                                            type="button" />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/management/settings/tabs/Billing.js
 **/